<template>
<div class="animated fadeIn">
  <div class="">
    <div class="card-body">
      <div class="row">
        <div v-if="showReview == true" v-html="chapterContent.content"></div>
        <div v-if="previousPage == true || nextPage == true || backToChap == true">
          <template v-for="item in traingnPage.root">
            <div v-html="item.content"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default
{
  name: 'FormPreview',
  props: ['chapterContent', 'traingnPage', 'showReview', 'previousPage', 'nextPage', 'backToChap'],
  data: function()
  {
    return {

    }
  },
  created()
  {
    var me = this;
  },
  methods:
  {

  },
  computed:
  {

  }
}
</script>
